import { Metamodel } from '../base/model';
import { StringDataFlowType } from '../dataflow/dataflow-datatype';
import { DocumentForm } from '../dataflow/dataflow-source';
import { DataFlowExpression } from '../dataflow/dataflowexpression';
import { JsonSettings } from '../dataflow/dataset-settings/json-settings';
import { adfDataMapperJsonSettings } from './adfDataMapper.const';

@Metamodel.model({
    name: adfDataMapperJsonSettings
})
export class AdfDataMapperJsonSettings extends JsonSettings {
    public documentForm: DataFlowExpression;
    public unquotedColumnNames: boolean;
    public hasComments: boolean;
    public singleQuoted: boolean;
    public backslashEscape: boolean;

    public initialize(subFormat: string): void {
        super.initialize(subFormat);
        this.documentForm = this.transform.createTemplatableExpression(StringDataFlowType.TYPE, DocumentForm.documentPerLine);
        this.unquotedColumnNames = false;
        this.hasComments = false;
        this.singleQuoted = false;
        this.backslashEscape = false;
    }
}
